import { Skeleton } from '@mui/material'
import React from 'react'

type LoadingValueProps = {
  loading?: boolean
  width?: number | string
  height?: number
  variant?: 'text' | 'rounded' | 'rectangular'
  children?: React.ReactNode
  fallback?: React.ReactNode
}

export function LoadingValue({
  loading = false,
  width = 72,
  height = 18,
  variant = 'text',
  children,
  fallback = null,
}: LoadingValueProps) {
  if (loading) {
    return <Skeleton variant={variant} width={width} height={height} />
  }

  const hasValue = !(children === null || children === undefined || children === false || children === '')
  return <>{hasValue ? children : fallback}</>
}
